module.exports = __webpack_public_path__ + "static/media/icon_material_developer_board_white.39f83100.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_material_developer_board_white.svg
// module id = 718
// module chunks = 0